import { IntelligenceFormFieldsEnum } from "@src/pages/intelligence-search/enum";
import { SmlAsset } from "@src/types/intelligence-search";
import { decodeConfigFromBase64 } from "@src/util/intelligence-search/params-configs";
import { FormInstance } from "antd";
import dayjs from "dayjs";
import React, { createContext, useContext } from "react";

type IntelligenceSearchContextType = {
    form: FormInstance<any>;
    assetsMeta: SmlAsset[];
};

export const IntelligenceSearchContext = createContext({} as IntelligenceSearchContextType);

export const IntelligenceSearchProvider: React.FC<{
    children: React.ReactNode;
    assetsMeta: SmlAsset[];
    form: FormInstance<any>;
}> = ({ children, assetsMeta, form }) => {
    return (
        <IntelligenceSearchContext.Provider
            value={{
                form,
                assetsMeta,
            }}
        >
            {children}
        </IntelligenceSearchContext.Provider>
    );
};
export const useIntelligenceSearchContext = () => useContext(IntelligenceSearchContext);
